export default "__VITE_ASSET__BLB35yat__"